module.exports = __webpack_public_path__ + "static/img/green products card_03.c73cdf1c.jpg";